export { default as ANIM } from './animation';
export { default as STYLES } from './styles';
export { default as PALETTE } from './palette';
